import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'separarPorMayuscula',
    standalone: false
})
export class SepararPorMayusculaPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .trim();
}

}
